import React, { useState } from "react";
import "./Footer.css";
import { FaInstagram, FaLinkedinIn } from "react-icons/fa";
import footerBg from "../assets/footer.jpg";

const Footer = () => {
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const sendEmail = async (e) => {
    e.preventDefault();

    setLoading(true);
    setSent(false);

    const formData = {
      business_name: e.target.business_name.value,
      name: e.target.name.value,
      email: e.target.email.value,
      phone: e.target.phone.value,
      city: e.target.city.value,
      country: e.target.country.value,
      website: e.target.website.value,
      service: e.target.service.value,
      business_details: e.target.business_details.value,
      goals: e.target.goals.value,
    };

    try {
      const response = await fetch(
        "https://vibeweb-media.onrender.com/send-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (data.success) {
        setSent(true);
        e.target.reset();
      } else {
        alert("Failed to send inquiry.");
      }
    } catch (error) {
      console.log(error);
      alert("Something went wrong.");
    }

    setLoading(false);
  };

  return (
    <div
      id="inquiry"
      className="footer"
      style={{ backgroundImage: `url(${footerBg})` }}
    >
      <div className="footer-overlay">
        <div className="footer-container">

          {/* LEFT NAV */}
          <div className="footer-column">
            <h3>Navigate To</h3>

            <ul>
              <li>
                <a href="#home" className="hover:text-yellow-400 transition">
                  Home
                </a>
              </li>

              <li>
                <a href="#about" className="hover:text-yellow-400 transition">
                  About Us
                </a>
              </li>

              <li>
                <a href="#services" className="hover:text-yellow-400 transition">
                  Services
                </a>
              </li>

              <li>
                <a href="#work" className="hover:text-yellow-400 transition">
                  Our Work
                </a>
              </li>

              <li>
                <a href="#about2" className="hover:text-yellow-400 transition">
                  Why Choose Us
                </a>
              </li>

              <li>
                <a href="#brands" className="hover:text-yellow-400 transition">
                  Brands
                </a>
              </li>

              <li>
                <a href="#connect" className="hover:text-yellow-400 transition">
                  Connect With Us
                </a>
              </li>

              <li>
                <a href="#verticals" className="hover:text-yellow-400 transition">
                  Verticals
                </a>
              </li>
            </ul>
          </div>

          {/* CASE STUDIES */}
          <div className="footer-column">
            <h3>Case Studies</h3>

            <ul>
              <li>Search Engine Optimization</li>
              <li>Social Media Marketing</li>
              <li>Paid Marketing</li>
              <li>Website Development</li>
              <li>Digital Content & Branding</li>
              <li>Influencer Marketing</li>
            </ul>
          </div>

          {/* GEO */}
          <div className="footer-column">
            <h3>Geo Specific Offerings</h3>

            <ul>
              <li>SEO Services in Dubai</li>
              <li>SEO Services in France</li>
              <li>SEO Services in Germany</li>
              <li>Digital Services in Spain</li>
              <li>Digital Services in New York City</li>
              <li>Digital Services in Pune</li>
            </ul>
          </div>

          {/* FORM */}
          <div className="footer-column form-section">
            <h3>Let’s Grow Your Business</h3>

            <form onSubmit={sendEmail}>

              <input
                name="business_name"
                placeholder="Business Name *"
                required
              />

              <input
                name="name"
                placeholder="Contact Person Name *"
                required
              />

              <input
                name="email"
                type="email"
                placeholder="Email *"
                required
              />

              <input
                name="phone"
                placeholder="Contact Number *"
                required
              />

              <input
                name="city"
                placeholder="City *"
                required
              />

              <input
                name="country"
                placeholder="Country *"
                required
              />

              <input
                name="website"
                placeholder="Website URL (optional)"
              />

              <select name="service" required>
                <option value="">Select Service *</option>
                <option>SEO</option>
                <option>Social Media Marketing</option>
                <option>Google Ads</option>
                <option>Website Development</option>
                <option>Content Marketing</option>
                <option>Branding</option>
                <option>Influencer Marketing</option>
                <option>Email Marketing</option>
              </select>

              <textarea
                name="business_details"
                placeholder="Tell us about your business *"
                required
              ></textarea>

              <textarea
                name="goals"
                placeholder="Your marketing goals *"
                required
              ></textarea>

              <button
                className="footer-button transition duration-300 bg-[radial-gradient(rgba(255,255,200,0.25),transparent_70%)]"
                type="submit"
                disabled={loading}
              >
                {loading ? "Sending..." : "Submit Request"}
              </button>

              {sent && (
                <p className="success-msg">
                  Inquiry submitted successfully!
                </p>
              )}

            </form>
          </div>
        </div>

        {/* CONTACT INFO */}
        <div className="footer-bottom">
          <div className="footer-contact">

            {/* LEFT SIDE */}
            <div className="contact-left">

              <h4>Reach out to us</h4>

              <p>
                <span>Email:</span>{" "}
                <a
                  href="mailto:info@vibewebmedia.com"
                  className="email-link"
                >
                  info@vibewebmedia.com
                </a>
              </p>

              <p>
                <span>Locations:</span> Europe, USA, Australia, India
              </p>

            </div>

            {/* RIGHT SIDE */}
            <div className="social-icons flex items-center gap-4">

              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="icon"
              >
                <FaInstagram size={25} />
              </a>

              <a
                href="https://www.linkedin.com/company/vibewebmedia"
                target="_blank"
                rel="noopener noreferrer"
                className="icon"
              >
                <FaLinkedinIn size={25} />
              </a>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
